import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import React, { useEffect } from "react";
import "./index.scss";
const Toast = ({
  message,
  type = "success",
  autoClose = 3000,
  position = "top-right",
  theme = "light",
  id = "unique-toast"
}) => {
  useEffect(() => {
    if (message) {
      if (!toast.isActive(id)) {
        toast(message, { type, autoClose, position, theme, toastId: id });
      }
    }
  }, [message, type, autoClose, id]);

  return <ToastContainer />;
};

export default Toast;
